import React from 'react'
import styled from 'styled-components'
import NoImage from '../../assets/images/no-image.jpg'

type ImageProps = {
  base64String?: string
}

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

const StyledImage = styled.img`
  display: block;
  margin: auto;
`

const Image: React.FC<ImageProps> = ({ base64String }) => {
  const imageSrc = `data:image/jpeg;base64,${base64String}`

  return (
    <ImageContainer>
      <StyledImage src={base64String ? imageSrc : NoImage} alt="Image" />
    </ImageContainer>
  )
}

export default Image
